(ns app.front.view.admin.migration.change-user-domain
  (:require [app.front.view.admin.migration.template :as admin-migration-template]
            [core.front.event :refer [>evt]]))

(defn view [match]
  [admin-migration-template/admin-page-for-migration
   {:task-id   :app.admin.migration.task/change-email-domain
    :args      [{:id          :from-domain
                 :label       "From old domain name"
                 :placeholder "evolta.fi"}
                {:id          :to-domain
                 :label       "To new domain name"
                 :placeholder "cloudpermit.com"}]
    :title     "Change username / email domain for all matching users"
    :help-text (str "This tool allows you to migrate username / email domain at one go for all users with the old domain"
                    " name. The users will not be notified of the change. They can only login with their new username "
                    " after the migration. Second administrator authorization will be required to start the task.")}
   match])

(def route
  {:name        :view/admin.migration.change-user-domain
   :view        view
   :controllers [{:start (fn [_]
                           (>evt [::admin-migration-template/fetch-migration-tasks
                                  :app.admin.migration.task/change-email-domain]))}]})
